module.exports = __webpack_public_path__ + "montserrat-bolditalic-webfont.68cbb1f5af8836393978.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-bolditalic-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-bolditalic-webfont.woff
// module chunks = styles